import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

// initial state
import { state as mainState } from './modules/index.js'
import { clientsList } from './modules/clients-list.js'

const state = Object.assign({}, mainState, clientsList)

// getters
const getters = {
    /**
     * Base products with ordered list of child products
     * @param state
     */
    products: state => state.products
}

// actions
const actions = {
}

// mutations
const mutations = {
    // mobile navigation menu
    openExpander (state) {
        state.navExpanderOpen = true;
    },
    closeExpander (state) {
        state.navExpanderOpen = false;
    }
}

/* eslint-disable no-new */
export default new Vuex.Store({
    state,
    actions,
    getters,
    mutations
})



// WEBPACK FOOTER //
// ./src/store/index.js